import React, { useContext } from "react";
import { SecurityContext } from "../../context/SecurityContextProvider";

export function DashboardPage() {
  const { getUsuarioAutenticado } = useContext(SecurityContext);
  //return "Bienvenido: Legajo Colaborador ";
  return <span>Bienvenido: {getUsuarioAutenticado().nombres}</span>;
}
